import { useCallback } from 'react';

import type { UserSnappyGiftData } from '../../../stores/user-snappy-gifts/types';
import { useStores } from '../../../stores/useStores';

interface UseSnappyGiftWidgetData {
  event: UserSnappyGiftData;
}

export function useSnappyGiftWidgetData(props: UseSnappyGiftWidgetData) {
  const { event } = props;
  const { userSnappyGiftsStore } = useStores();

  const widgetImageUrl = event.widgetImageUrl;

  const handleClick = useCallback(() => {
    userSnappyGiftsStore.openSnappyGiftDialogById(event.id);
  }, [event, userSnappyGiftsStore]);

  return { widgetImageUrl, handleClick };
}
